module.exports = __webpack_public_path__ + "img/demo-preview.817d1d3c.jpg";